import type { RefObject } from 'react';

import { serializeHistogramConfig } from './serialize-histogram-config.js';
import type { HistogramChartConfiguration } from '../../../histogram/types/histogram-props.js';
import type { HistogramChartRef } from '../../../histogram/types/histogram-ref.js';
import type { XYChartRef } from '../../../xy-chart/types/xy-chart.js';

/**
 * Builds the Histogram-shaped imperative handle for `HistogramToXY`.
 *
 * - All programmatic interaction methods are delegated to the inner
 *   `XYChart` ref.
 * - `getConfig()` returns a Histogram-shaped serialized payload built from
 *   the resolved `HistogramChartConfiguration` (see
 *   `serializeHistogramConfig`).
 */
export const buildHistogramImperativeHandle = (
  xyRef: RefObject<XYChartRef | null>,
  config: HistogramChartConfiguration,
): HistogramChartRef => ({
  get element() {
    return xyRef.current?.element ?? null;
  },
  getConfig: () => serializeHistogramConfig(config),
  downloadData: () => xyRef.current?.downloadData(),
  exploreMode: () => xyRef.current?.exploreMode(),
  zoomMode: () => xyRef.current?.zoomMode(),
  panMode: () => xyRef.current?.panMode(),
  zoomIn: () => xyRef.current?.zoomIn(),
  zoomOut: () => xyRef.current?.zoomOut(),
  reset: () => xyRef.current?.reset(),
});
